<template>
  <div class="flex xl:hidden">
    <button type="button" class="header__link header__link--primary" @click.prevent="openMenu" aria-label="Abrir menu">
      <i class="icon far fa-bars text-2xl" aria-hidden="true"></i>
    </button>

    <drawer ref="drawer" @close="resetMenu">
      <transition-group tag="div" class="ept-drawer__container" name="slide">
        <div v-if="isBaseOpen" class="w-full absolute flex flex-col" key="base">
          <a v-if="userEmail != ''" class="header__link drawer-menu__item flex justify-between bg-white user-item" href="#" @click="openSubmenu('user')">
            <div class="flex gap-2">
              <div class="flex flex-col justify-center">
                <user-avatar :avatar-url="userPhoto" />
              </div>
              <div class="flex flex-col">
                <span class="ept-user__name">{{ userEmail }}</span>
                <span class="ept-user__name font-thin" v-if="userAdmin == 'true'">Administrador</span>
              </div>
            </div>
            <i class="chevron far fa-chevron-right"></i>
          </a>
          <a class="header__link drawer-menu__item" href="#" @click="openSubmenu('ept')">
            <i class="icon text-center fal fa-compass"></i>
            <span>O que é EPT?</span>
            <i class="chevron far fa-chevron-right"></i>
          </a>
          <a class="header__link drawer-menu__item" href="/ept-em-numeros">
            <i class="icon text-center fal fa-chart-bar"></i>
            <span>EPT em Números</span>
          </a>
          <a class="header__link drawer-menu__item" href="#" @click="openSubmenu('article')">
            <i class="icon text-center fal fa-book"></i>
            <span>Conteúdos</span>
            <i class="chevron far fa-chevron-right"></i>
          </a>
          <!-- <a class="header__link drawer-menu__item" href="#" @click="openSubmenu('tool')">
            <i class="icon text-center fal fa-toolbox"></i>
            <span>Ferramentas</span>
            <i class="chevron far fa-chevron-right"></i>
          </a> -->
          <a class="header__link drawer-menu__item" href="#" @click="openSubmenu('notice')">
            <i class="icon text-center fal fa-newspaper"></i>
            <span>Acontece</span>
            <i class="chevron far fa-chevron-right"></i>
          </a>
          <a class="header__link drawer-menu__item" href="#" @click="openSubmenu('state')">
            <i class="icon text-center epti epti-brazil"></i>
            <span>Estados</span>
            <i class="chevron far fa-chevron-right"></i>
          </a>
          <div class="flex justify-center py-8">
            <slot name="login" />
          </div>
        </div>

        <mobile-submenu v-if="isUserOpen" key="user" @back="resetMenu">
          <div class="px-4">
            <slot name="user" />
          </div>
        </mobile-submenu>

        <mobile-submenu v-if="isEptOpen" key="tools" @back="resetMenu">
          <a class="header__link drawer-menu__item" href="/sobre-ept">
            <i class="icon"></i>
            <span>Descrição e princípios</span>
          </a>
          <a class="header__link drawer-menu__item" href="/sobre-ept/formas-de-oferta">
            <i class="icon"></i>
            <span>Formas de oferta</span>
          </a>
          <a class="header__link drawer-menu__item" href="/sobre-ept/governanca">
            <i class="icon"></i>
            <span>Governança</span>
          </a>
          <a class="header__link drawer-menu__item" href="/sobre-ept/linha-do-tempo">
            <i class="icon"></i>
            <span>Linha do Tempo</span>
          </a>
          <a class="header__link drawer-menu__item" href="/sobre-ept/legislacao">
            <i class="icon"></i>
            <span>Legislação</span>
          </a>
          <a class="header__link drawer-menu__item" href="/sobre-ept/links-uteis">
            <i class="icon"></i>
            <span>Links úteis</span>
          </a>
          <a class="header__link drawer-menu__item" href="/perguntas-frequentes">
            <i class="icon"></i>
            <span>Perguntas frequentes</span>
          </a>
        </mobile-submenu>

        <mobile-submenu v-if="isIndicatorOpen" key="tools" @back="resetMenu">
          <a class="header__link drawer-menu__item" href="/dados/ept-em-numeros">
            <i class="icon"></i>
            <span>Dados Nacionais</span>
          </a>
        </mobile-submenu>

        <mobile-submenu v-if="isArticleOpen" key="articles" @back="resetMenu">
          <a class="header__link drawer-menu__item" href="/conteudos/publicacoes">
            <i class="icon"></i>
            <span>Publicações</span>
          </a>
          <a class="header__link drawer-menu__item" href="/conteudos/podcasts">
            <i class="icon"></i>
            <span>Podcasts</span>
          </a>
          <a class="header__link drawer-menu__item" href="/conteudos/videos">
            <i class="icon"></i>
            <span>Vídeos</span>
          </a>
          <a class="header__link drawer-menu__item" href="/conteudos/materiais-pedagogicos">
            <i class="icon"></i>
            <span>Materiais Pedagógicos</span>
          </a>
        </mobile-submenu>

        <mobile-submenu v-if="isToolOpen" key="tool" @back="resetMenu">
          <a class="header__link drawer-menu__item" href="/ferramentas/categorizacao-de-cursos">
            <i class="icon"></i>
            <span>Cursos Técnicos por Categoria e Complexidade</span>
          </a>
          <a class="header__link drawer-menu__item" href="/ferramentas/curso-para-implementacao-de-curriculo-em-tecnologia">
            <i class="icon"></i>
            <span>Curso para implementação de Currículo em Tecnologia</span>
          </a>
          <a class="header__link drawer-menu__item" href="/ferramentas/instrumento-de-prontidao">
            <i class="icon"></i>
            <span> Competências gerais para o mundo do trabalho </span>
          </a>
          <a class="header__link drawer-menu__item" href="/ferramentas/localizacao-de-escolas-e-cursos">
            <i class="icon"></i>
            <span>Localização de escolas e cursos</span>
            <span class="ml-4 text-xs text-center text-white border rounded-md bg-green-500 bg-center h-6 w-10 p-1 my-auto">NOVO</span>
          </a>
        </mobile-submenu>

        <mobile-submenu v-if="isNoticeOpen" key="notice" @back="resetMenu">
          <a class="header__link drawer-menu__item" href="/acontece/noticias">
            <i class="icon"></i>
            <span>Notícias</span>
          </a>
          <a class="header__link drawer-menu__item" href="/acontece/eventos">
            <i class="icon"></i>
            <span>Agenda (Eventos)</span>
          </a>
        </mobile-submenu>

        <mobile-submenu v-if="isStateOpen" key="state" @back="resetMenu">
          <a class="header__link drawer-menu__item" href="/estados/boas-praticas">
            <i class="icon"></i>
            <span>Boas Práticas</span>
          </a>
          <a class="header__link drawer-menu__item" href="/estados/panorama">
            <i class="icon"></i>
            <span>Panorama</span>
          </a>
        </mobile-submenu>
      </transition-group>
    </drawer>
  </div>
</template>

<script>
import Drawer from '../shared/Drawer'
import MobileSubmenu from './mobile/Submenu'
import UserAvatar from './UserAvatar'

export default {
  components: {
    Drawer,
    MobileSubmenu,
    UserAvatar
  },

  props: {
    userEmail: {
      type: String,
      required: true
    },
    userPhoto: {
      type: String,
      default: ''
    },
    userAdmin: {
      type: String,
      required: true
    }
  },

  data: () => ({
    step: 'base'
  }),

  computed: {
    isArticleOpen() {
      return this.step === 'article'
    },

    isBaseOpen() {
      return this.step === 'base'
    },

    isUserOpen() {
      return this.step === 'user'
    },

    isEptOpen() {
      return this.step === 'ept'
    },

    isIndicatorOpen() {
      return this.step === 'indicator'
    },

    isNoticeOpen() {
      return this.step === 'notice'
    },

    isStateOpen() {
      return this.step === 'state'
    },

    isToolOpen() {
      return this.step === 'tool'
    },
  },

  methods: {
    openMenu() {
      this.$refs.drawer.open()
    },

    openSubmenu(step) {
      this.step = step
    },

    resetMenu() {
      this.step = 'base'
    }
  }
}
</script>

<style lang="scss">
@import "~stylesheets/vars";
.header__link.drawer-menu__item {
  display: flex;
  align-items: center;
  font-size: 1.125rem;
  line-height: 1.15;
  @apply py-4;
  @apply mr-0;
  border-bottom: 1px solid $stroke-gray;

  .chevron {
    flex: none;
    color: $blue-light;
  }

  .icon {
    flex: none;
    font-size: 1.375rem;
    width: 1.75rem;
    margin-right: 0.5rem;
  }

  span {
    flex-grow: 1;
  }
}
</style>

<style lang="scss" scoped>
.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
  opacity: 0;
}
</style>
